export const APPLY_DELIVERY_UPCHARGE = 'Apply Delivery Upcharge';
export const DELIVERY_UPCHARGE = 'Delivery Upcharge';
export const ROUND_PRICES = 'Round Prices';
export const ROUND_PRICES_TO_NEAREST = 'Round Prices to Nearest';
